import type { AcademyCandidateDto } from "@/entities/academy/domain/dtos";
import { InvitationRecipientType } from "@/entities/academy/domain/enums";
import { singleton } from "tsyringe";

export interface AcademyBehaviorStructure {
    isCandidateStudent: (dto: unknown) => dto is AcademyCandidateDto;
    isValidSmsTarget: (
        target: InvitationRecipientType,
        candidateState: AcademyCandidateDto,
    ) => boolean;
}

@singleton()
export class AcademyBehavior implements AcademyBehaviorStructure {
    public isCandidateStudent = (dto: unknown): dto is AcademyCandidateDto => {
        return dto != null && dto instanceof Object && !("type" in dto);
    };

    public isValidSmsTarget = (
        target: InvitationRecipientType,
        candidateState: AcademyCandidateDto,
    ): boolean => {
        if (target === InvitationRecipientType.Parent) {
            return candidateState.parentPhoneNumber !== undefined;
        }

        if (target === InvitationRecipientType.Student) {
            if (candidateState.phoneNumber) {
                return candidateState.phoneNumber.subscriberNumber !== undefined;
            }
            return candidateState.phoneNumber !== undefined;
        }

        return true;
    };
}
